module.exports = __webpack_public_path__ + "static/media/bird.7ec3ecb0.jpg";